/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from '@azure/msal-browser';

const tenantId = 'f66b6bd3-ebc2-4f54-8769-d22858de97c5';// process.env.REACT_APP_MSAL_TENANT_ID || 'dd9d4c56-df50-433b-b359-9bb038843bc0';// 'f66b6bd3-ebc2-4f54-8769-d22858de97c5'; //'dd9d4c56-df50-433b-b359-9bb038843bc0';

const clientId = 'af07bd24-f890-4c25-b0f5-c62404db8f09';// process.env.REACT_APP_MSAL_CLIENT_ID || 'a59e4677-d0e9-40aa-94c7-a953be8754de';// 'af07bd24-f890-4c25-b0f5-c62404db8f09'; //'a59e4677-d0e9-40aa-94c7-a953be8754de';

const redirectUri = 'https://testplan.harman.com/auth/response-oidc';//process.env.REACT_APP_MSAL_REDIRECT_URI || `${window.location.origin}/auth/response-oidc`;// 'https://be.testplan.harman.com/auth/response-oidc'; //`${window.location.origin}/auth/response-oidc`;

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig: Configuration = {
    auth: {
        // MSAL needs the Entra Application (client) ID GUID from an OIDC/OAuth2 App Registration.
        // The previous App ID URI value made the browser flow look like it was targeting the SAML app.
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // User.Read matches the Microsoft Graph delegated permission configured in Entra for this SSO demo.
    // MSAL adds the OIDC sign-in scopes automatically around this request.
    scopes: ['User.Read'],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };